module.exports = __webpack_public_path__ + "img/director-test-icon7.51bada07.png";